module.exports = __webpack_public_path__ + "static/media/Transform Your.faeac793.png";